import type { FileStorage } from "../types/FileStorage"
import type { FileStorageBackend } from "../types/FileStorageBackend"
import { Init } from "@pdfking/reactivity/preact"
import { IterableToArray, Keys, Void } from "@pdfking/tfunc"
import { BaseProviderMixin } from "./base"

export default (store: FileStorage): FileStorageBackend =>
  Init({
    data: { store },
    methods: {
      cleanup: Void,
      open_files: store.open,
      open_folders: (file_ids: string[]) =>
        Promise.all(file_ids.map((s: string) => store.startswith(s).then(Keys)))
          .then(a => IterableToArray(...a))
          .then(store.open),
      refresh: Void,
    },
    mixins: [BaseProviderMixin],
  })
